import React, { useState } from "react";
import classes from "./Checkout.module.css";
import translate from "../../service/Language";
import Currecy from "../../service/Currency";
import axios from "axios";
import { toast } from "react-toastify";

function Checkout({
  totalCoastGet,
  productsInCart,
  oneClick,
  oneClickProduct,
  setToggle,
  setCheckout,
}) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  const URI_API = `https://api.telegram.org/bot${process.env.REACT_APP_TOKEN}/sendMessage`;

  var products = [];

  const GET_TG = () => {
    productsInCart && Object.values(JSON.parse(productsInCart)).map((item, index) =>
      products.push(
        index +
        1 +
        ". " +
        item.title_uz +
        " " +
        Currecy(item.price) +
        " UZS dan " +
        item.inCart +
        "ta\n"
      )
    );

    let message = `<b>MEHRIBONSHOP.UZ</b>\n\n`;
    message += `<b>Sotib olmoqchi: </b>\n`;
    message += `<b>Ismi: </b> ${name}\n`;
    message += `<b>Telefon raqami: </b> ${phone}\n`;

    if (oneClick) {
      message += `<b>Product: </b>\n ${oneClickProduct}\n`;
      message += `<b>Barcha Narx: </b> <b>${Currecy(oneClick)}</b> UZS\n`;
    } else {
      message += `<b>Productlar: </b>\n${products.join().replace(/\,/g, "")}\n`;
      message += `<b>Barcha Narx: </b> <b>${Currecy(totalCoastGet)}</b> UZS\n`;
    }
    message += `<b>Vaqt: </b> ${new Date().toLocaleDateString()}`;

    axios
      .post(URI_API, {
        chat_id: process.env.REACT_APP_CHAT_ID,
        parse_mode: "html",

        text: message,
      })
      .then((res) => {
        setName("");
        setPhone("");
      })
      .catch((err) => { })
      .finally(() => {
        setName("");
        setPhone("");
        setToggle(false);
        setCheckout(false);
        toast.success(translate("Отправлен!", "Yuborildi!"));
      });
  };

  return (
    <>
      <div className={classes.Checkout}>
        <form
          action="GET"
          onSubmit={(e) => {
            e.preventDefault();
            GET_TG();
          }}
        >
          <h3>
            {translate("Сумма: ", "Narx: ")}
            {oneClick ? Currecy(oneClick) : Currecy(totalCoastGet)} UZS
          </h3>
          <div className={classes.label_input}>
            <label htmlFor="name">
              {translate("Введите ваше имя", "Ismingizni kiriting")}
            </label>
            <input
              type="text"
              name=""
              id="name"
              required
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
          <div className={classes.label_input}>
            <label htmlFor="number">
              {translate(
                "Введите свой номер телефона",
                "Telefon raqamingizni kiriting"
              )}
            </label>
            <input
              type="number"
              name=""
              id="number"
              required
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </div>
          <button>{translate("Купить", "Sotib olish")}</button>
        </form>
      </div>
    </>
  );
}

export default Checkout;
